import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Award, Pencil } from "lucide-react";
import { fmtPct, roleLabel, GOLD } from "@/lib/prime";
import { PrimeResultDialog } from "./PrimeResultDialog";
import { PrimeLevel } from "./PrimeLevel";

function Item({ label, value, testId, gold }) {
  return (
    <span className="text-xs text-slate-500" data-testid={testId}>{label}:{" "}
      <b className={`font-semibold ${value ? "text-slate-800" : "text-slate-400 font-normal"}`} style={gold && value ? { color: "#8A6D0B" } : undefined}>{value || "Not recorded"}</b></span>
  );
}

export function PrimeSummary({ personId }) {
  const { viewAs } = useAuth();
  const [data, setData] = useState(null);
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => { api.get(`/prime/person/${personId}`).then((r) => setData(r.data)).catch(() => setData({ agencies: [] })); }, [personId]);
  useEffect(() => { load(); }, [load]);
  if (!data) return null;
  const ags = data.agencies;
  return (
    <div className="mt-1.5 space-y-1" data-testid="prime-summary">
      {ags.length === 0 && (
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Award className="w-3.5 h-3.5" style={{ color: GOLD }} />
          <Item label="Achievement Level" testId="prime-level" /><Item label="Prime Score" testId="prime-score" /><Item label="Reporting month" testId="prime-period" />
          <span className="text-[11px] text-slate-400">No Agency relationship on file</span>
        </div>)}
      {ags.map((a) => {
        const c = a.current;
        return (
          <div key={a.business_id} className="flex flex-wrap items-center gap-x-4 gap-y-1" data-testid={`prime-agency-${a.business_id}`}>
            <Award className="w-3.5 h-3.5" style={{ color: GOLD }} aria-hidden />
            {(ags.length > 1 || a.role === "staff") && <span className="text-xs font-medium text-slate-700">{a.business_name}{a.role === "staff" ? "" : ` (${roleLabel(a.role)})`}</span>}
            {a.role === "staff" && <span className="text-[11px] rounded-full bg-slate-100 text-slate-600 px-2 py-0.5" data-testid="prime-staff-label">Agency result — not an individual score</span>}
            <Item label="Achievement Level" value={c?.level ? <PrimeLevel level={c.level} /> : null} testId="prime-level" gold={c?.level === "PRIME"} />
            <Item label="Prime Score" value={fmtPct(c?.score_pct)} testId="prime-score" />
            <Item label="Reporting month" value={c?.period_label} testId="prime-period" />
            {a.can_edit && !viewAs && <button onClick={() => setEdit(a)} className="text-xs text-[#006090] inline-flex items-center gap-1 hover:underline" data-testid={`prime-edit-${a.business_id}`}><Pencil className="w-3 h-3" />Update</button>}
          </div>);
      })}
      {edit && <PrimeResultDialog agency={edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />}
    </div>
  );
}
